import { jsonp } from '@ifeng-fe/ui_base';

// apiUrl为webpack注入的全局变量
/* eslint-disable */
let apiBaseUrl = apiUrl;

/* eslint-enable */

// 获取自媒体文章主页数据
const getWeMediaMainData = async params => {
    const data = await jsonp('//c1.m.ifeng.com/api_wemedia_index', {
        data: params,
        jsonpCallback: 'showData',
        cache: false,
    });

    return data ? data : null;
};

/**
 * 自媒体主页获取马甲号账号详情接口
 * @param {Number} cid 自媒体账号id
 * @returns {Object} accountDetail,自媒体账户信息
 */
const getShareSockpuppetAccountDetail = async cid => {
    const accountDetail = await jsonp(
        `${apiBaseUrl}/ishare/getSockPuppetAccountInfo/${cid}/getShareSockpuppetAccountDetail`,
        {
            jsonpCallback: 'getShareSockpuppetAccountDetail',
            cache: 120,
        },
    );

    if (accountDetail.code === 0 && accountDetail.data && accountDetail.data.success) {
        return accountDetail.data;
    }

    return accountDetail.data;
};

/**
 * 获取自媒体主页文章或视频列表数据
 * @param {String} id 自媒体账号ID
 * @param {String} type 类型
 * @param {Number} page 页码
 * @returns {Array} 返回数组
 */
const getShareListData = async params => {
    const { id, type, page } = params;
    const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;
    const proid = isVideoShare ? 'ifengvideoh5' : 'ifengnewsh5';

    const listData = await jsonp(`${apiBaseUrl}/ishare/getShareListData/${id}/${type}/${page}/${proid}/getListData`, {
        jsonpCallback: 'getListData',
        cache: 120,
    });

    return listData;
};

// 获取自媒体个人主页数据
const getWeMediaPersonalData = async params => {
    const data = await jsonp('//user.iclient.ifeng.com/social_api_feeds/myList', {
        data: params,
        jsonpCallback: 'showData',
        cache: false,
    });

    return data ? data : null;
};

// 获取自媒体个人主页数据
const getFans = async id => {
    const data = await jsonp(`https://shankapi.ifeng.com/api/ishare/account/fans/${id}/getFansCallback`, {
        jsonpCallback: 'getFansCallback',
        cache: false,
    });

    return data ? data : null;
};

export { getWeMediaMainData, getShareSockpuppetAccountDetail, getShareListData, getWeMediaPersonalData, getFans };
